import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { SUPPORT_EMAIL } from 'enums/info-enums';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const ContactUs = ({ onCancel, modalVisible }) => {
  return (
    <Modal visible={modalVisible} footer={null} title={null} onCancel={onCancel}>
      <ContactUs.ModalInnerContainer>
        <ContactUs.ContactModalTitle>Contact Us</ContactUs.ContactModalTitle>
        <ContactUs.HelpSpan>We&apos;re here to help!</ContactUs.HelpSpan>
        <ContactUs.HelpEmail href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</ContactUs.HelpEmail>
      </ContactUs.ModalInnerContainer>
    </Modal>
  );
};

ContactUs.ModalInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 438px;
  height: 223px;
`;

ContactUs.ContactModalTitle = styled.span`
  color: ${COLORS.primaryModalText};
  font-size: 20px;
  line-height: 19px;
  font-weight: 500;
  font-family: ${FONTS.default};
  margin-top: 7px;
  text-transform: capitalize;
`;

ContactUs.HelpSpan = styled.span`
  font-weight: 400;
  font-family: ${FONTS.default};
  font-size: 14px;
  line-height: 20px;
  margin-top: 60px;
  color: ${COLORS.secondaryModalText};
`;

ContactUs.HelpEmail = styled.a`
  font-weight: 400;
  font-family: ${FONTS.default};
  font-size: 14px;
  line-height: 20px;
  margin-top: 27px;
  color: ${COLORS.primaryModalText};
  text-transform: lowercase;
  border-bottom: 1px solid ${COLORS.primaryModalBorder};
  letter-spacing: 0.25px;

  &:hover,
  &:focus {
    text-decoration: none;
    color: ${COLORS.primaryModalText};
  }
`;

ContactUs.propTypes = {
  onCancel: PropTypes.func,
  modalVisible: PropTypes.bool,
};

export default ContactUs;
